import {toEither} from 'Core/models/Async';
import * as E from 'fp-ts/lib/Either';
import {constant} from 'fp-ts/lib/function';
import {pipe} from 'fp-ts/lib/pipeable';
import React, {ComponentType} from 'react';
import {connect} from 'react-redux';
import {ReducerState} from 'rootReducer';
import {UserClaims} from 'Users/models/Claims';
import {getUserClaims} from 'Users/selectors/userProfileSelectors';

type WithUserClaimsProps = ReturnType<typeof mapStateToProps>;
export type WithClaimsProps = {
  claims: UserClaims;
};

const withUserClaims = <TProps extends {}>(
  WrappedComponent: ComponentType<TProps & WithClaimsProps>
): ComponentType<Omit<TProps, keyof WithClaimsProps>> => {
  const Component = connect(mapStateToProps)((props: WithUserClaimsProps) => {
    return pipe(
      props.userClaims,
      toEither,
      E.fold(constant(<></>), claims => <WrappedComponent {...(props as any)} claims={getUserClaims(claims)} />)
    );
  });

  return (props: Omit<TProps, keyof WithClaimsProps>) => <Component {...props} />;
};

const mapStateToProps = (state: ReducerState) => ({
  userClaims: state.user.profile.userClaims,
});

export default withUserClaims;
